/* tslint:disable */
/* eslint-disable */
export enum RoleEnum {
  Operatore = 'OPERATORE',
  Caporeparto = 'CAPOREPARTO',
  Responsabile = 'RESPONSABILE',
  Supervisore = 'SUPERVISORE',
  GodamAdministrator = 'GODAMAdministrator',
  Buyer = 'BUYER',
}
